// extracted by mini-css-extract-plugin
export default {"l_AlertIconBtn_main":"AlertIconBtn_l_AlertIconBtn_main__+4zH-"};